import { ISetScheduleParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetRunFlowTasksScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setRunFlowTasksSchedule', {
      ids: ids,
      scheduleId: scheduleId,
    });
  }
}
